import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const PUFETH_URL = 'https://api-v2.puffer.fi/backend-for-frontend/tvl/all'
const pufEth = 'PUFETH'

export const pufethFetcher: YieldFetcher = {
  label: 'PUFETH',
  fetch: async () => {
    const res = await fetch(PUFETH_URL, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }).then((r) => r.json())
    return { [pufEth]: apyToAprPercent(res.apy) }
  },
}
